import { render, staticRenderFns } from "./plans.component.vue?vue&type=template&id=c63e553e"
import script from "./plans.component.ts?vue&type=script&lang=ts&external"
export * from "./plans.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63e553e')) {
      api.createRecord('c63e553e', component.options)
    } else {
      api.reload('c63e553e', component.options)
    }
    module.hot.accept("./plans.component.vue?vue&type=template&id=c63e553e", function () {
      api.rerender('c63e553e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/plans/plans.component.vue"
export default component.exports